import React, { useState, useEffect } from 'react';
import { useLanguage } from '../../../context/LanguageContext';
import { useNavigate } from 'react-router-dom';
import { loginUser } from '../../../api/api_users';
import logo from '../../assets/logotypes/logo_white.png';
import { GoogleLoginButton, FacebookLoginButton, TwitterLoginButton } from "react-social-login-buttons";

function Login() {
  const { translations } = useLanguage();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const navigate = useNavigate();

  const handleSubmit = async (event) => {
    event.preventDefault();
    try {
      await loginUser(email, password, setError, navigate);
    } catch (error) {
      setError(translations.error_login);
      console.error('Login error:', error);
    }
  };
  

  const handleChange = (setter) => (event) => {
    setter(event.target.value);
  };

  const handleSocialLogin = (social) => {
    setError("This functionality has not yet been implemented")
    // TODO
  };

  return (
    <div className="login-page">
        <div className="login-container">
        <img src={logo} alt="" className="login-image"></img>
          <form onSubmit={handleSubmit}>
            <input
              type="email"
              placeholder={translations.email}
              value={email}
              onChange={handleChange(setEmail)}
              className="login-input"
            />
            <input
              type="password"
              placeholder={translations.pass}
              value={password}
              onChange={handleChange(setPassword)}
              className="login-input"
            />
            {error && <div className="login-error">{error}</div>}
            <button type="submit" className="login-button general-button">{translations.login}</button>
            <div className="social-buttons-container">
              <GoogleLoginButton className="socialButton" onClick={() => handleSocialLogin("Google")} />
              <FacebookLoginButton className="socialButton" onClick={() => handleSocialLogin("Facebook")} />
              <TwitterLoginButton className="socialButton" onClick={() => handleSocialLogin("Twitter")} />
            </div>
            <div>
              <button onClick={() => navigate('/register')} className="login-button fastSettings-button">{translations.sign_up}</button>
            </div>
          </form>
          <p className="login-recovery" onClick={() => navigate('/forgotPassword')}>{translations.forgot_pass}</p>
        </div>
    </div>
  );
}

export default Login;
